import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=55421863&scoped=true&"
import script from "./authorize.vue?vue&type=script&lang=tsx&"
export * from "./authorize.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55421863",
  null
  
)

export default component.exports